export const fonts = {
  heading: '"Roboto", Helvetica, Tahoma, Arial, sans-serif',
  body: '"Roboto", Helvetica, Tahoma, Arial, sans-serif',
}
